// extracted by mini-css-extract-plugin
module.exports = {"notifications":"AddNotificationModalContent-notifications-3aXnF"};